import * as accountGetters from "./account/getters.js";
import * as customerGetters from "./customer/getters.js";
import * as sellInquiryFormGetters from "./sellInquiryForm/getters.js";
import * as contractGetters from "./contract/getters.js";
export default {
	...accountGetters,
	...customerGetters,
	...sellInquiryFormGetters,
	...contractGetters,
};
